<section class="listRequests" [style]="{ 'background-color': landing2 ? 'transparent' : '#2c2a29', 'color': landing2 ? '#000' : '#fff' }">
  <div style="width: 100%;" [style]="{ 'max-width': landing2 ? '1440px' : '1196px'}">
  <div class="listRequestContainer">
    <header *ngIf="!landing2" class="listRequests--header">
      <section>
        <mat-button-toggle-group
          class="btnGroup"
          name="favoriteColor"
          aria-label="Favorite Color"
        >
          <mat-button-toggle
            *ngFor="let type of requestsTypeList"
            (click)="changeRequestType(type)"
            [value]="type"
            [checked]="type === 'requests'"
            class="toggleBtn"
            >{{
              translate.translateRequestListTypes(type) | uppercase
            }}</mat-button-toggle
          >
        </mat-button-toggle-group>
      </section>
    </header>
    <header *ngIf="landing2" class="d-flex w-100 justify-content-start align-items-center my-4">
      <h2 class="my-2 text-left">{{ 'landing2MyVehicles' | i18next }}</h2>
    </header>
    <main class="main" [style]="{ 'width': landing2 ? '100%' : '90%', padding: landing2 ? '0' : '0 20px' }">
      <nav *ngIf="!landing2" class="main--nav" [style]="{ 'border-bottom': landing2 ? '2px solid #e9ecef !important' : 'solid 1px white !important' }">
        <button
          [style]="{
            'border-bottom': data === 'active' ? (landing2 ? 'solid 4px black' : 'solid 0.1em #C8F546') : 'none',
            'color': landing2 ? '#000' : '#fff'
          }"
          class="main--nav__btn"
          (click)="changeRequestStatus('active')"
          matButton
        >
          {{ 'actives' | i18next | uppercase }}
        </button>
        <button
          [style]="{
            'border-bottom': data === 'inactive' ? (landing2 ? 'solid 4px black' : 'solid 0.1em #C8F546') : 'none',
            'color': landing2 ? '#000' : '#fff'
          }"
          class="main--nav__btn"
          (click)="changeRequestStatus('inactive')"
          matButton
        >
          {{ 'inactive' | i18next | uppercase }}
        </button>
      </nav>
      <div class="text-center spinner-container" *ngIf="spinner">
        <div class="spinner-border spinner" role="status"></div>
      </div>
      <p class="text" *ngIf="vehiclesError">{{ vehiclesError }}</p>
      <app-list-item
        *ngIf="!vehiclesError"
        [requestType]="requestType"
        [data]="listRequest"
        [state]="data"
        [dataPagination]="dataPagination"
        (pageEmitter)="updatePage($event)"
        (updateListEmitter)="updateList()"
        type="vehicles"
      ></app-list-item>
    </main>
  </div>
  </div>
</section>
